import { render, staticRenderFns } from "./MatCapPreview.vue?vue&type=template&id=fb4a7108&"
import script from "./MatCapPreview.vue?vue&type=script&lang=js&"
export * from "./MatCapPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports